import React from 'react';
import { EXPERTS } from '@guuru/expert-common';
import { str2hsl } from '@guuru/theme-common';
import type { SizedAvatarProps } from './SizedAvatar';
import SizedAvatar from './SizedAvatar';

const handleImgLoadError = (e?: React.ChangeEvent<HTMLImageElement>) => {
  if (e === undefined) {
    return false;
  }
  e.target.onerror = null;
  e.target.src = EXPERTS.default.photoUrl;
  return false;
};

interface AvatarProps extends SizedAvatarProps {
  text?: string;
}

const Avatar = function ({
  src = undefined,
  className = '',
  style = {},
  shape = 'circle',
  size = 'default',
  text = undefined,
}: AvatarProps) {
  const url = src || EXPERTS.default.photoUrl;
  const initials = text?.split(' ').map((n) => n[0]).join('');
  return (
    <SizedAvatar
      style={{
        ...style,
        backgroundColor: text ? str2hsl(text) : undefined,
      }}
      shape={shape}
      size={size}
      $size={className}
      src={url === EXPERTS.default.photoUrl ? undefined : url}
      onError={handleImgLoadError}
      alt=""
    >
      {initials}
    </SizedAvatar>
  );
};

export default Avatar;
